import { buildQuery } from '../helpers';
import { GET_PENDING_APPROVAL_STEP_RESULTS, GET_PENDING_APPROVAL_STEP_RESULTS_SUCCESS, GET_PENDING_APPROVAL_STEP_RESULTS_FAIL, GET_PENDING_APPROVAL_STEP_RESULTS_PENDING_TOTAL, GET_PENDING_APPROVAL_STEP_RESULTS_PENDING_TOTAL_SUCCESS, GET_PENDING_APPROVAL_STEP_RESULTS_PENDING_TOTAL_FAIL, RESET_PENDING_APPROVAL_STEP_RESULTS, } from '../constants';
import APPROVAL_STATUSES from '../constants/approvalStepStatuses';
export function getPendingApprovalStepResults(courseId, params) {
    const query = buildQuery(params);
    return {
        types: [
            GET_PENDING_APPROVAL_STEP_RESULTS,
            GET_PENDING_APPROVAL_STEP_RESULTS_SUCCESS,
            GET_PENDING_APPROVAL_STEP_RESULTS_FAIL,
        ],
        promise: (fetch) => fetch(`/api/approval-steps/${courseId}/approval-steps-results-approver?${query}`, {
            method: 'GET',
        }),
    };
}
export function getPendingApprovalStepResultsPendingTotal(courseId) {
    const query = buildQuery({
        page: 1,
        perPage: 1,
        status: APPROVAL_STATUSES.WAITING_FOR_REVIEW,
    });
    return {
        types: [
            GET_PENDING_APPROVAL_STEP_RESULTS_PENDING_TOTAL,
            GET_PENDING_APPROVAL_STEP_RESULTS_PENDING_TOTAL_SUCCESS,
            GET_PENDING_APPROVAL_STEP_RESULTS_PENDING_TOTAL_FAIL,
        ],
        promise: (fetch) => fetch(`/api/approval-steps/${courseId}/approval-steps-results-approver?${query}`, {
            method: 'GET',
        }),
    };
}
export function resetPendingApprovalStepResults() {
    return {
        type: RESET_PENDING_APPROVAL_STEP_RESULTS,
    };
}
